<template lang="html">
  <div class="transitionBars" :class="{openedBars}">
    <div class="bar--left"></div>
    <div class="bar--right"></div>
  </div>
</template>

<script>
export default {
  name: 'TransitionBars',
  computed: {
    openedBars() {
      return this.$store.state.openedBars;
    }
  }
}
</script>

<style lang="scss">
.transitionBars {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
  pointer-events: none;
  &.openedBars {
    .bar {
      opacity: 0;
      transition: transform 1s cubic-bezier(0.645, 0.045, 0.355, 1), opacity .1s linear 1.4s;
    }
    .bar--left {
      transform: translateY(100%);
    }
    .bar--right {
      transform: translateY(-100%);
    }
  }
  .bar {
    height: 100%;
    width: calc(50% + 1px);
    position: fixed;
    top: 0;
    background-color: var(--Neu11);
    transition: transform 1s cubic-bezier(0.645, 0.045, 0.355, 1), opacity .1s linear;
    &--left {
      @extend .bar;
      left: 0;
      transform: translateY(0);
      opacity: 1;
    }
    &--right {
      @extend .bar;
      right: 0;
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TransitionBars.vue